module.exports = __webpack_public_path__ + "static/media/cover-poser.c8dc8a5d.webp";